<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-29 10:41:41
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-07 18:30:13
 * @Description: file content
 首页入口
 -->
<template>
  <div class="t9">
    <T9HF v-if="isHuafa"></T9HF>
    <T9ZD v-else-if="isZd"></T9ZD>
    <T9SF v-else-if="isSf"></T9SF>
    <T9ALEJ v-else-if="isAlej"></T9ALEJ>
    <T9LFS v-else-if="isLfs"></T9LFS>
    <T9DEFAULT v-else></T9DEFAULT>
  </div>
</template>

<script>
import util from "@/utils/utils";

const T9HF = () => import("@/components/t9/t9_hf");
const T9ZD = () => import("@/components/t9/t9_zd");
const T9SF = () => import("@/components/t9/t9_sf");
const T9ALEJ = () => import("@/components/t9/t9_alej");
const T9LFS = () => import("@/components/t9/t9_lfs");
const T9DEFAULT = () => import("@/components/t9/t9_default");

export default {
  components: {
    T9DEFAULT,
    T9ALEJ,
    T9ZD,
    T9SF,
    T9LFS,
    T9HF
  },
  props: {},
  data() {
    return {
      isHuafa: util.checkIsHuafa(), //是否华发
      isZd: util.checkIsZd(), //是否中电
      isAlej: util.checkIsAlej(), //是否安联
      isSf: util.checkIsSf(), //是否中电
      isLfs: util.checkIsShlfsj(), //是否莱佛士教育
      // isHuafa: false, //是否华发
      // isZd: false, //是否中电
      // isAlej: true, //是否安联
      // isSf: false, //是否中电
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
</style>